import Policy from '@/features/termAndPrivacy/pages/Policy'

export default Policy
